import { Phone, Mail } from 'lucide-react';

export default function Team() {
  const teamMembers = [
    {
      name: 'Herr G. Kolarov',
      role: 'Geschäftsführer',
      description: 'Über 10 Jahre Erfahrung in Umzüge ins Ausland',
      image: '/DSC_0187.jpg',
      scale: 'scale-110',
      position: 'object-[center_45%]',
    },
    {
      name: 'Frau D. Kolarov',
      role: 'Geschäftsführerin',
      description: 'Über 10 Jahre Erfahrung in internationalen Umzügen und Kundenbetreuung',
      image: '/DSC_0168 copy.jpg',
      scale: 'scale-110',
      position: 'object-[center_45%]',
    },
    {
      name: 'Herr R. Rothenbühler',
      role: 'Umzugsberater',
      description: 'Über 5 Jahre Erfahrung in Auslandsumzügen, Verzollungen und Logistik',
      image: '/Herr-Rothenbuehler-Umzugsberater copy.jpg',
      scale: 'scale-100',
      position: 'object-center',
    },
  ];

  return (
    <section id="team" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Unser Experten-Team
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Erfahrene Umzugsprofis, die Sie persönlich und kompetent beraten
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-2xl"
              >
                <div className="relative h-80 overflow-hidden bg-white">
                  <img
                    src={member.image}
                    alt={`${member.name} - ${member.role}`}
                    className={`w-full h-full object-contain ${member.position} transition-transform duration-500 hover:scale-150 ${member.scale}`}
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-slate-900 mb-2">{member.name}</h3>
                  <p className="text-slate-600 font-medium mb-3">{member.role}</p>
                  <p className="text-sm text-slate-500 italic mb-4">{member.description}</p>
                  <div className="space-y-2 text-sm text-slate-600">
                    <div className="flex items-center justify-center space-x-2">
                      <Phone className="w-4 h-4" />
                      <a href="tel:0800700100" className="hover:text-slate-900 transition">
                        0800 700 100
                      </a>
                    </div>
                    <div className="flex items-center justify-center space-x-2">
                      <Mail className="w-4 h-4" />
                      <a href="mailto:info@umzugprofis.ch" className="hover:text-slate-900 transition">
                        info@umzugprofis.ch
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
